module.exports = __webpack_public_path__ + "assets/img/travel-day42.676c2644.png";